import * as React from 'react';

function SvgBookingCountdown(props) {
  return (
    <svg width={11} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.25.75a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm0 9.61a4.36 4.36 0 11.002-8.72 4.36 4.36 0 01-.002 8.72z"
        fill="#6B92F3"
      />
      <path
        d="M7.297 7.482l-1.67-1.208v-2.9a.094.094 0 00-.094-.094h-.564a.094.094 0 00-.094.094V6.6c0 .03.014.059.039.076l1.938 1.414c.042.03.1.02.131-.02l.335-.457a.093.093 0 00-.02-.131z"
        fill="#6B92F3"
      />
    </svg>
  );
}

export default SvgBookingCountdown;
